import { Injectable } from '@angular/core';
import Statsig from 'statsig-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TagStatsigService {
  // private initialization;
  constructor() {
    // Constructor kept for potential future initialization
  }

  async initialize() {
    return await Statsig.initialize(
      environment.STATSIG_SDK_KEY,
      { userID: '3cFQfT58JnuE4gZslpeSrR' },
      {
        environment: { tier: environment.ENVIRONMENT_NAME },
        fetchMode: 'cache-or-network',
      }, // optional, pass options here if needed
    );
  }

  // get tagObject(){
  //   return Statsig;
  // }
}
